'use client';

import { useQuery } from '@tanstack/react-query';
import { clients } from '../clients';
import { QueryKey } from './QueryKey';
import useDebounce from './useDebounce';

export function useTeams({
  userPosition,
  search,
}: {
  userPosition?: { lat: number; lng: number } | null;
  search?: string | null;
}) {
  const debouncedSearch = useDebounce(search, 500);
  const {
    data: teams,
    isInitialLoading: teamsLoading,
    isError: teamsError,
  } = useQuery({
    queryKey: [
      QueryKey.Team,
      ...(userPosition?.lat && userPosition?.lng
        ? [userPosition?.lat, userPosition?.lng]
        : []),
      ...[search ? debouncedSearch : undefined],
    ],
    queryFn: () => {
      return clients.team.getAll({
        query: {
          lat: userPosition?.lat,
          long: userPosition?.lng,
          search: search ?? undefined,
        },
      });
    },
  });

  return { teams: teams?.data, teamsLoading, teamsError };
}
